<!--
 * @Author: your name
 * @Date: 2020-08-13 15:02:31
 * @LastEditTime: 2022-12-09 13:45:12
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/contact-details/index.vue
-->
<style scoped lang="sass">
.contact
  padding-left: 16px
  padding-right: 16px
  padding-bottom: 60px !important
  background: #fff

.email
  margin-top: 20px

.footer_bar_absolute
  font-weight: bold

.phone
  display: flex
  align-items: center
  justify-content: space-between

  .country_select_box
    align-self: flex-end
    display: flex
    justify-content: center
    align-items: center
    width: 130px
    height: 56px
    margin-right: 12px
    background: #F7F7F7

  .phone_num
    flex: 1

.bottom
  margin-top: 2px !important
  padding-bottom: 30px

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)

  .push-from-bottom
    bottom: 18px !important

  .multiselect__tags
    padding-top: 15px
    background: #F7F7F7 !important
    border: none

  .multiselect__select
    padding-top: 15px

  .py_form_item_box
    padding: 20px 0 0 0

  .i-form-item-message
    bottom: -18px !important
    color: #B00020 !important

  .check_box
    display: flex
    align-items: center
    height: 18px
    margin-top: 10px
    font-size: 12px
    color: var(--menu-primary-text-colour) !important

  input
    color: var(--menu-primary-text-colour) !important
    font-weight: 400

  .icon
    font-size: 25px

.wrong_info
  height: 0
  color: rgba(176, 0, 32, 1)

  font-size:12px
  line-height: 14px
  margin-bottom: 25px
  overflow: hidden
  margin-top: 12px
  transition: .3s all ease

.text
  margin-left: 10px

.wrong_info_dispear
  height: 50px

.ns
  margin-top: 14px

.email_input
  ::v-deep
    .box
      .label
        &.wrong
          color: rgba(51, 68, 85, 0.45) !important
</style>

<template lang="pug">
  .contact_box
    py-form.contact.overflow_scroll(
      ref="form"
      id="scroll_bar"
      :model="userInfo"
      :rules="ruleValidate"
    )
      .user_name
        py-form-item.phone_num(prop='userName')
          py-input(
            v-model="userInfo.userName"
            :title='t("name", "Name")'
            type="text"
            isContact
            icon="person"
            size="25"
            @pyBlur="val => userInfo.userName = userInfo.userName.trim()"
            @focus="clearValidate(0)"
          )
      .phone
        .country_select_box
          CountrySelect.select(
            v-model="country"
            :countriesList="countriesList"
          )

        py-form-item.phone_num(prop='phoneNumber')
          py-input(
            v-model="userInfo.phoneNumber"
            :title='t("phone_number", "Phone number")'
            type="number"
            isContact
            :size="25"
            icon="phone_iphone"
            @input="val => userInfo.phoneNumber = userInfo.phoneNumber.trim()"
            @focus="clearValidate(1)"
          )
      main-text.ns(
        :detail="phoneDetail"
      )
      py-form-item(prop='emailNumber')
        py-input.email_input(
          v-model="userInfo.emailNumber"
          maxlength="50"
          type="email"
          :title="email"
          isContact
          :size="25"
          @focus="clearValidate(2)"
          @pyBlur="val => userInfo.emailNumber = userInfo.emailNumber.trim()"
        )
      main-text.ns(
        :detail="emailDetail"
      )
      check-age.check(
        v-if="includeAlcohol && !isFromMenuToContactDetail"
        :name="ageCheckName"
        :wrongAge="wrongAge"
        :ageCheck.sync="ageCheck"
        :ageAskText="ageAskText"
        :wrongAgeText="wrongAgeText"
        @change="changeAge"
      )
        template(v-slot:age-info)
          main-text.ns(
            :title="age"
            :detail="ageInfo"
          )
    footer-common.footer_bar_absolute(
      :disabled="!isVenueOpenTime"
      :text="nextButtonText"
      @clickButton="checkNextStep(beforeNext)"
    )
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import mixin from '@/utils/mixin'
import dayjs from 'dayjs'
import SmallIcon from 'components/SmallIcon'
import MainText from './component/MainText'
import CountrySelect from 'components/CountrySelect'
import CheckAge from './component/CheckAge'
import { addOrder, addUser, getDeliveryCost, getUser, getUserOrders } from '@/api/product'
import { massageSubGroupCart, buildSubGroupOrderPayload, resolvePostPaidTarget, placeSubGroupOrder } from './subGroupOrder'
import { mapState } from 'vuex'
import countriesList from '@/plugins/countries'
import parsePhoneNumber from 'libphonenumber-js'
import resizeHandler from 'utils/resizeHandler'
import { NO_INPUT_TABLE_NUMBER } from 'utils/constants'
import { MessageDialog } from '@/plugins/createApi'
import { t } from '@/utils/language'
import { orderAmountNow, subGroupOrderAmountNow, ensureSubGroupSurchargeSources } from '@/utils/surchargeSnapshot'
import { getVenueQuietly } from '@/api/venueQuiet'
import { withOrderMenu } from '@/utils/menu/qrMenu'
import { menuEntry } from '@/utils/menu/qrEntry'
import { ORDER_NOT_PLACED, failedOrder, orderOutcomeOf } from '@/utils/orderPlaced'

const emailNumberRule = (rule, value, callback) => {
  const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  if (!reg.test(value)) {
    callback(new Error('Please provide a vaild email adddress'))
  }
  callback()
}

const phoneNumberRule = (rule, value, callback) => {
  value = value.trim()
  const reg = /^\d{1,}$/
  if (isNaN(value)) {
    callback(new Error('PhoneNumber format is incorrect'))
  }
  if (!reg.test(value)) {
    callback(new Error(t('required', 'Required')))
  }
  if (value.length < 6) {
    callback(new Error('PhoneNumber is greater than 6'))
  }
  if (value.length > 14) {
    callback(new Error('PhoneNumber is greater less than 14'))
  }
  callback()
}

// User name input box, form verification rules
// 用户名称输入框，表单校验规则
const userNameRule = (rule, value, callback) => {
  if (!value.trim()) {
    callback(new Error(t('required', 'Required')))
  }
  callback()
}

@Component({

  requiredComponents: ['global-popup', 'element-ui'],
  props: {
    venueSubGroupId: {
      type: String,
    }
  },

  async created() {
    this.$store.commit('showLoading')
    if (this.isSubgroupCart) {
      await this.__checkVenueSubgroupOpenTime()
    } else {
      await this.__checkVenueOpenTime()
    }
  },

  computed: {
    ...mapState(['venueId', 'isFromMenuToContactDetail']),
    ...mapState({
      isOnline: state => state.app.isOnline,
      spDiscounts: state => state.spDiscounts,
      routerInfo: state => state.venueHome.routerInfo,
      venueCountry: state => state.venueHome.venueCountry,
      includeAlcohol: state => state.cart.includeAlcohol,
      deliveryInfo: state => state.contactDetails?.deliveryInfo[state.venueId] ?? {},
      venueDeliverySetting: state => state.venueHome.deliverySetting,
      venueAverageWaitingTime: state => state.venueHome.averageWaitingTime,
      venueSystemDefaultWaitingTime: state => state.venueHome.systemDefaultWaitingTime,
    }),

    // Reactive i18n labels / 响应式 i18n 标签
    nextButtonText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('next', 'NEXT')
    },
    email() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('email_address', 'Email address')
    },
    phoneDetail() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('required_to_identify', 'Required to identify your order & provide order updates.') + ' ' + t('not_used_for_marketing', 'It will not be used for marketing.')
    },
    emailDetail() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('email_for_tax_receipt', 'Your email will only be used to send you a tax receipt.')
    },
    ageAskText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('age_ask_text', 'Yes, I\'m 18 or older')
    },
    wrongAgeText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('wrong_age_text', 'Your need to be 18 or older to order products that contain alcohol. Please remove these products from your cart before continuing.')
    },
    age() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('age_verification', 'Age verification')
    },
    ageInfo() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('age_info', 'Your order contains Alcohol. Please confirm that you are 18 or older. You may be required to show ID to the venue.')
    },

    padding() {
      return this.$store.state.app.request
    },

    /**
     * @return {Number} Total waiting time set by the restaurant
     */
    /**
     * @return {Number} 餐厅设置的等待总时间
     */
    nowDeliveryTime() {
      // If venueAverageWaitingTime is off, the default setting is 10 minutes
      // 若 venueAverageWaitingTime 为关闭状态，则默认设置为 10 分钟
      const venueAverageWaitingTime = this.venueAverageWaitingTime ? this.venueAverageWaitingTime : 600
      const time = Number(venueAverageWaitingTime) + Number(this.venueSystemDefaultWaitingTime)
      return (time / 60).toFixed()
    },

    isSubgroupCart() {
      return this.$route.name.includes('venue-sub-group') && this.venueSubGroupId
    },

    // Sub group shopping cart, grouped by venue, with combo add-ons de-duplicated.
    // Mirror of payment/index.vue subGroupCart — keeps the pay-later cartList payload
    // the same shape as the gateway (pre-paid) path so both flows send the same data.
    // 子组购物车,按店铺分组,去掉套餐重复配菜;镜像 payment/index.vue 的 subGroupCart
    subGroupCart() {
      if (this.isSubgroupCart) {
        return massageSubGroupCart(this.$store.getters.venueSubGroupItemList(this.venueSubGroupId))
      } else {
        return {}
      }
    },

    isSpMode() {
      return this.$route.path.includes('/v/sp/') || this.$route.meta?.isSpMode === true
    }
  },

  watch: {
    padding(val) {
      if (this.userId || this.notificationKey) {
      } else {
        this.$store.commit('closeLoading')
      }
    },

    wrongAge(val) {
      if (val) {
        setTimeout(() => {
          window.scrollTo({
            top: 3000,
            left: 0,
            behavior: 'smooth'
          })
        }, 100)
      }
    },
    isMobile: {
      immediate: true,
      handler(val) {
        this.isPhone = val
      }
    },
  },

  components: {
    SmallIcon,
    MainText,
    CountrySelect,
    CheckAge,
  }
})

class ContactDetails extends mixins(mixin, resizeHandler) {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  wrongAge = false
  ageCheckName = 'checked'
  ageCheck = ''
  country = {}
  countriesList = countriesList

  ruleValidate = {
    phoneNumber: [
      {
        validator: phoneNumberRule,
        trigger: 'blur'
      }
    ],
    emailNumber: [
      {
        required: true,
        message: t('required', 'Required'),
        trigger: 'blur'
      },
      {
        validator: emailNumberRule,
        trigger: 'blur'
      }
    ],
    userName: [
      {
        validator: userNameRule,
        trigger: 'blur'
      },
    ],
  }

  userInfo = {
    phoneNumber: '',
    emailNumber: '',
    userName: '',
  }

  phoneTitle = 'Please provide your phone number'
  phoneTitleConfrim = 'Please provide your phone number'
  emailTitle = 'Please provide your email address'
  emailTitleConfrim = 'Please provide your email address'
  userNameTitle = 'Please provide your name'
  userNameTitleConfirm = 'Please provide your name'
  text = ''
  userId = ''
  notificationKey = ''
  // Guards the sub group pay-later branch against a double-click placing two orders before
  // showLoading takes effect. Sub-group scoped only — the single-store path is untouched.
  subGroupSubmitting = false

  /**
   * Clear form validation when the input box gets focus
   * @param {Number} index Index of the current form item
   */
  /**
   * 输入框获取焦点时，清除表单验证
   * @param {Number} index 当前表单项的索引
   */
  clearValidate(index) {
    this.$refs.form.fields[index]._clearValidate()
  }

  changeAge(val) {
    console.log(val)
    this.wrongAge = !val
  }

  async checkNextStep(beforeNext) {
    if (this.isSubgroupCart) {
      await this.__checkVenueSubgroupTodayIsOpenTime(beforeNext)
    } else {
      await this.__checkVenueTodayIsOpenTime(beforeNext)
    }
  }

  _getCountry() {
    return this.countriesList.filter(item => {
      if (item.code.toLowerCase() === this.venueCountry.toLowerCase()) {
        return item
      }
    })
  }

  async mounted() {
    this.userId = localStorage.getItem('userId') || ''
    this.notificationKey = localStorage.getItem('notificationKey') || ''
    if (this.userId || this.notificationKey) {
      this.phoneTitle = this.phoneTitleConfrim
      this.emailTitle = this.emailTitleConfrim
      this.userNameTitle = this.userNameTitleConfirm
      await this._getUserInfo()
    } else {
      this.country = this._getCountry()[0]
      this.$store.commit('closeLoading')
    }
  }

  // Create Order
  // 创建订单
  async createOrder() {
    const state = this.$store.state
    // 先算 amount 再拼请求：重判费率会顺带更新 state.details（surchargeRate），不靠对象字面量里键的先后（review 第 1 轮 #8）
    const amount = orderAmountNow(this.$store, this.venueId)
    const data = {
      amount,
      subtotal: this.$store.getters.total(this.venueId),
      currency: state.currency,
      details: state.details,
      type: 2,
      user: {
        ...state.contactDetails.user,
        id: localStorage.getItem('userId') || '',
        language: this.$store.state.language?.currentLanguage || 'en',
        currency: this.$store.state.currencySettings?.currentCurrency || '',
      },
      venueId: state.venueId,
      itemList: this.$store.getters.itemList(this.venueId),
      spDiscounts: this.spDiscounts,
      creatorType: 'qr',
      menuType: state.app.menuType
    }
    // SP 模式下添加 spMode 参数
    if (this.isSpMode) {
      data.spMode = true
    }
    if (this.$store.state.cart.includeAlcohol) {
      data.details.over18 = true
    }
    if (this.isOnline) {
      const deliveryInfo = this.deliveryInfo
      data.type = deliveryInfo.type
      data.user.address = deliveryInfo.rawAddress
      data.details.orderType = deliveryInfo.orderType
      data.details.googleDeliveryTime = deliveryInfo?.deliveryCost?.timeCost ?? deliveryInfo.googleDeliveryTime
      data.details.preOrderTimeSettings = (deliveryInfo.preOrderTimeSettings && deliveryInfo.preOrderTimeSettings !== 'Invalid Date') ? deliveryInfo.preOrderTimeSettings : ''
    }
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    const res = await addOrder(withOrderMenu(data, this.$store.state.menuId, menuEntry(this.$store.state, this.$route)))
    return res
  }

  // Additional order
  // 追加订单
  async AddOrder(unPaidOrderId) {
    const state = this.$store.state
    // 先算 amount 再拼请求：重判费率会顺带更新 state.details（surchargeRate），不靠对象字面量里键的先后（review 第 1 轮 #8）
    const amount = orderAmountNow(this.$store, this.venueId)
    const data = {
      amount,
      subtotal: this.$store.getters.total(this.venueId),
      currency: state.currency,
      details: state.details,
      type: 2,
      user: {
        ...state.contactDetails.user,
        id: localStorage.getItem('userId'),
        language: this.$store.state.language?.currentLanguage || 'en',
        currency: this.$store.state.currencySettings?.currentCurrency || '',
      },
      venueId: state.venueId,
      itemList: this.$store.getters.itemList(this.venueId),
      orderId: unPaidOrderId,
      spDiscounts: this.spDiscounts,
      creatorType: 'qr',
      menuType: state.app.menuType
    }
    // SP 模式下添加 spMode 参数
    if (this.isSpMode) {
      data.spMode = true
    }
    if (this.$store.state.cart.includeAlcohol) {
      data.details.over18 = true
    }
    if (this.isOnline) {
      const deliveryInfo = this.deliveryInfo
      data.type = deliveryInfo.type
      data.user.address = deliveryInfo.rawAddress
      data.details.orderType = deliveryInfo.orderType
      data.details.googleDeliveryTime = deliveryInfo?.deliveryCost?.timeCost ?? deliveryInfo.googleDeliveryTime
      data.details.preOrderTimeSettings = (deliveryInfo.preOrderTimeSettings && deliveryInfo.preOrderTimeSettings !== 'Invalid Date') ? deliveryInfo.preOrderTimeSettings : ''
    }
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    // 多版本菜单 B6（U-B6-2 review 第 1 轮 F1）：拒单 / 不知道追加上没有，都换成 failedOrder 标记交给调用方分（以前直接抛给调用方的 try/catch）
    const res = await addOrder(withOrderMenu(data, this.$store.state.menuId, menuEntry(this.$store.state, this.$route))).catch(error => failedOrder(error))
    return res
  }

  // Create a sub group (multi-venue) pay-later order.
  // 创建子组(跨店)后付款订单
  //
  // Backend contract (add-venue-sub-group-order): the server automatically reuses the
  // most recent unpaid parent order for this sub group (its own $latestOrder logic), so the
  // front end does NOT branch on new vs append — one call handles both. The response id/orderNo
  // is the parent order's, whether it was freshly created or reused.
  // 后端契约:add-venue-sub-group-order 会自动复用最近一张未付父单,所以这里不区分新建/追加,
  // 统一调用一次,用响应里的 id/orderNo 即可。
  async createSubGroupOrder() {
    const state = this.$store.state
    const getters = this.$store.getters
    // Field alignment mirrors this file's single-store createOrder() (type/user/currency/
    // creatorType/menuType/spMode/over18 — sub group is never delivery) and payment/index.vue's
    // isSubgroupPayment shape (amount/subtotal from sub group getters, venueSubGroupId, itemList: [], cartList).
    // 多店：先给缺判定依据的成员店补拉门店设置（上线前加购的 / 在别家店页面加的推荐品，Codex 第 2 轮 #3 / #4），
    // 再按建单这一刻、各成员店自己的配置重判附加费取合计（review 第 1 轮 #5；先算再拼请求，#8）
    await ensureSubGroupSurchargeSources(this.$store, { fetchVenue: getVenueQuietly })
    const amount = subGroupOrderAmountNow(this.$store, this.venueSubGroupId)
    const data = buildSubGroupOrderPayload({
      amount,
      subtotal: getters.subGroupCartTotal(this.venueSubGroupId),
      currency: state.currency,
      details: state.details,
      user: {
        ...state.contactDetails.user,
        id: localStorage.getItem('userId') || '',
        language: this.$store.state.language?.currentLanguage || 'en',
        currency: this.$store.state.currencySettings?.currentCurrency || '',
      },
      venueId: state.venueId,
      venueSubGroupId: this.venueSubGroupId,
      cartList: this.subGroupCart,
      menuType: state.app.menuType,
      isSpMode: this.isSpMode,
      includeAlcohol: this.$store.state.cart.includeAlcohol
    })
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    const res = await placeSubGroupOrder(data)
    return res
  }

  beforeNext() {
    this.$store.commit('closeLoading')
    this.clickButton()
  }

  _jumpToPayment() {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    if (this.isPhone) {
      if (this.isSubgroupCart) {
        this.$router.push(`/vgs/${this.venueSubGroupId}/payment?new=1`)
      } else {
        this.$router.push(`/v/${this.venueId}/payment?new=1`)
      }
    } else {
      this.$emit('next')
    }
  }

  _jumpToStartTab() {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    this.$router.push(`/v/${this.venueId}/tab-user/start-tab`)
  }

  _saveUserInfo() {
    this._saveEmailNumber(this.userInfo.emailNumber)
    this._savePhoneNumber(this.country.dial_code + this.userInfo.phoneNumber)
    this._saveUserName(this.userInfo.userName)
    this._saveOrderType()
  }

  clickButton() {
    // Have you come of age
    // 是否已成年
    let isAdult = true
    // Judge whether there are alcoholic products in the shopping cart
    // 判断购物车是否有含酒精商品
    if (this.includeAlcohol && !this.isFromMenuToContactDetail) {
      // When the adult option is not checked, you will be prompted to an error
      // 没有勾选已成年选项时，提醒报错
      if (!this.ageCheck) {
        isAdult = false
        this.wrongAge = true
      }
    }

    this.$refs.form.validate(async (valid) => {
      if (valid && isAdult) {
        this.$store.commit('showLoading')
        const userId = await this._addUser()
        this._saveUserInfo()

        if (!this.isSubgroupCart) {
          // interact for create tab
          if (this.isFromMenuToContactDetail) {
            this._jumpToStartTab()
            this.$store.commit('closeLoading')
            return
          }
        }
        await this._filterAndSaveUnfinishOrder(userId)
        const paymentType = this.routerInfo.paymentType
        if (paymentType === 'pre-paid') {
          this._jumpToPayment()
        } else {
          // Pay later
          // 后付款
          if (this.isSubgroupCart) {
            // Sub group (multi-venue) pay-later: build the whole-cart payload and place ONE
            // add-venue-sub-group-order. This covers every store in the cart (the single-store
            // path below only ever sent state.venueId, silently dropping the other venues).
            // The backend reuses the latest unpaid parent order if one exists, so no new/append
            // branch is needed here — see createSubGroupOrder() for the contract.
            // 子组(跨店)后付款:构造整车 payload 下一次 add-venue-sub-group-order,覆盖车里所有店铺
            if (this.subGroupSubmitting) return
            this.subGroupSubmitting = true
            try {
              const res = await this.createSubGroupOrder()
              // Guard both paths (counter + online): after BUG-2a the backend can return a
              // structured failure (success:false, no id) instead of an order. Without an id
              // we must NOT clear the cart or navigate to /vgs/:id/pay/undefined — bail so the
              // customer can retry with the cart intact.
              if (!res || !res.id) {
                console.log('createSubGroupOrder returned no order id, aborting')
                this.$store.commit('closeLoading')
                return
              }
              this._setShowMask()
              this.orderId = res.id
              this.orderNo = res.orderNo
              this._clearSubGroupCart()
              this._jumpToSubGroupPostPaidOrderPage()
            } catch (error) {
              console.log(error)
            } finally {
              this.subGroupSubmitting = false
            }
            this.$store.commit('closeLoading')
            return
          }
          try {
            let unPaidOrderNo = ''
            let unPaidOrderId = ''
            const index = this.$store.state.venueUnpaidOrderList.findIndex(item => item.venueId === this.venueId)
            if (index !== -1) {
              unPaidOrderNo = this.$store.state.venueUnpaidOrderList[index].unPaidOrderId
              unPaidOrderId = this.$store.state.venueUnpaidOrderList[index].unPaidOrderNo
            }
            if (!unPaidOrderNo) {
              const res = await this.createOrder()
              if (this.isOnline && !res) return
              this._setShowMask()
              this.orderId = res.id
              this.orderNo = res.orderNo
              this.clearProductList()
              this._jumpToPostPaidOrderPage()
            } else {
              try {
                const addRes = await this.AddOrder(unPaidOrderNo)
                // 多版本菜单 B6（U-B6-2 review 第 1 轮 F1，owner D1 = A）：后端明确说没追加上、或者请求根本没发（环境检查没过）⇒ 留在这页、车不动；
                // 不知道追加上没有（断网 / 超时 / 5xx）⇒ 清车、去那张未付单的付款页看服务器上的样子 —— 追加在后端没有幂等，留在这页再点一次会追加两遍
                if (orderOutcomeOf(addRes) !== ORDER_NOT_PLACED) {
                  console.log('追加order成功')
                  this.clearProductList()
                  this._jumpToPayPage(unPaidOrderNo, unPaidOrderId)
                }
              } catch (error) {
                console.log(error)
              }
            }
          } catch (error) {
            console.log(error)
          }
        }
        this.$store.commit('closeLoading')
      } else if (!valid) {
        // Scroll to the error location when the form verification fails
        // 表单验证未通过时，滚动至报错位置
        this.$nextTick(_ => {
          const errDom = document.querySelector('.error_form')
          if (errDom) {
            errDom.scrollIntoView({
              block: 'center',
              behavior: 'smooth',
            })
          }
        })
      } else {
        // Scroll to the adult option not checked
        // 页面位置滚动到没有勾选的已成年选项
        window.scrollTo({
          top: 3000,
          left: 0,
          behavior: 'smooth'
        })
      }
    })
  }

  _jumpToPayPage(unPaidOrderNo, unPaidOrderId) {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    this.$router.push({
      path: `/v/${this.venueId}/pay/${unPaidOrderNo}`,
      query: {
        orderNo: unPaidOrderId
      }
    })
  }

  async _filterAndSaveUnfinishOrder(userId) {
    // filter and save unOverOrders
    await this._updateUnfinishOrders(userId)
  }

  async _updateUnfinishOrders(userId) {
    const orders = await this._getUserUnOverOrders('nostart_all', userId)
    const ordersTotal = parseInt(orders.total)
    if (this.isSubgroupCart) {
      if (ordersTotal > 0) {
        const filtersOrder = orders.orders.filter(item => {
          if (item.paymentStatus === 0 && item.status <= 40) {
            return item
          }
        })
        if (filtersOrder.length > 0) {
          const order = filtersOrder[0]
          this._updateVenueSubgroupUnpaidOrderList(order.id, order.orderNo)
        } else {
          this.$store.commit('clearUnpaidVenueSubgroupOrder', this.venueSubGroupId)
        }
      } else {
        this.$store.commit('clearUnpaidVenueSubgroupOrder', this.venueSubGroupId)
      }
    } else {
      if (ordersTotal > 0) {
        const filtersOrder = orders.orders.filter(item => {
          if (item.paymentStatus === 0 && item.status <= 40) {
            return item
          }
        })
        if (filtersOrder.length > 0) {
          const order = filtersOrder[0]
          this._updateVenueUnpaidOrderList(order.id, order.orderNo)
        } else {
          this.$store.commit('clearUnpaidOrder', this.venueId)
        }
      } else {
        this.$store.commit('clearUnpaidOrder', this.venueId)
      }
    }
  }

  _updateVenueSubgroupUnpaidOrderList(orderId, orderNo) {
    this.$store.commit('saveVenueSubgroupUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: orderId,
      unPaidOrderNo: orderNo,
    })
  }

  _updateVenueUnpaidOrderList(orderId, orderNo) {
    this.$store.commit('saveVenueUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: orderId,
      unPaidOrderNo: orderNo,
    })
  }

  async _getUserUnOverOrders(type, userId) {
    const res = await getUserOrders({
      venueId: this.venueId ?? 'unknown',
      venueSubGroupId: this.venueSubGroupId ?? null,
      id: userId || localStorage.getItem('userId'),
      type: type,
      pageSize: 5,
      pageNo: 1
    })
    return res
  }

  clearProductList() {
    this.$store.commit('clearProductList')
    // 与下面 `_clearSubGroupCart()` 及仓里其余清车点对齐：清车就得连着清折扣。
    // 这个方法只在 `createOrder` / `AddOrder` 成功之后调（:729 / :735），折扣已经
    // 随那一单提交出去了；不清的话空车 + 存量 `discountAmount` 会算出负数总价。
    this.$store.commit('clearDiscounts')
  }

  // Sub group carts live in venueHome.subGroupCartList (cleared by clearVenueSubGroupProductList),
  // not the venueId-filtered state.productList that clearProductList touches. Mirror the payment
  // page's clearProductListAndUnpaidOrder so the whole cart + discounts clear on success — otherwise
  // the sub group cart survives and the customer can re-place the order.
  _clearSubGroupCart() {
    this.$store.commit('clearVenueSubGroupProductList')
    this.$store.commit('clearProductList')
    this.$store.commit('clearDiscounts')
  }

  _saveOrderType() {
    let orderType = localStorage.getItem('orderType')
    if (!orderType && this.$store?.state?.details?.orderType) orderType = this.$store?.state?.details?.orderType
    if (orderType === 'takeaway') {
      this.$store.commit('addDetailsProp', {
        prop: 'orderType',
        val: 'takeaway'
      })
    } else {
      this.$store.commit('addDetailsProp', {
        prop: 'orderType',
        val: 'dine-in'
      })
    }
  }

  _saveVenueUnpaidOrderList() {
    this.$store.commit('saveVenueUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: this.orderId,
      unPaidOrderNo: this.orderNo,
    })
  }

  _setShowMask() {
    const status = localStorage.getItem('showMask')
    if (!status) localStorage.setItem('showMask', 'show')
  }

  _jumpToPostPaidOrderPage() {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    this.$router.push({
      path: `/v/${this.venueId}/pay/${this.orderId}`,
      query: {
        orderNo: this.orderNo
      }
    })
  }

  // Sub group equivalent of _jumpToPostPaidOrderPage: lands on the vgs order detail page
  // (the /vgs/:id/pay/:orderId route resolves to venue-sub-group/orderDetail, the double
  // order-number page). Uses the sub group order id/orderNo from the add response.
  // 子组版跳转:落到 vgs 订单详情页(双单号页)
  _jumpToSubGroupPostPaidOrderPage() {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    this.$router.push(resolvePostPaidTarget({
      isSubgroupCart: true,
      venueSubGroupId: this.venueSubGroupId,
      orderId: this.orderId,
      orderNo: this.orderNo
    }))
  }

  _saveEmailNumber(val) {
    const email = val.trim()
    this.$store.commit('addUserProp', {
      prop: 'email',
      val: email
    })
  }

  _savePhoneNumber(val) {
    const phone = val.trim()
    this.$store.commit('addUserProp', {
      prop: 'phone',
      val: phone
    })
  }

  _saveUserName(val) {
    const name = val.trim()
    this.$store.commit('addUserProp', {
      prop: 'name',
      val: name
    })
  }

  // Get user information
  // 获取用户信息
  async _getUserInfo() {
    const res = await getUser({
      id: this.userId,
      notificationKey: this.notificationKey
    }).catch(function (error) {
      console.log(error)
    })
    if (res && res.name) {
      const parsePhone = parsePhoneNumber(res.phone)
      if (parsePhone && parsePhone.countryCallingCode) {
        this.country = this.countriesList.find(item => item.dial_code === `+${parsePhone.countryCallingCode}`)
        this.userInfo.phoneNumber = parsePhoneNumber(res.phone).nationalNumber
      }
      this.userInfo.emailNumber = res.email
      this.userInfo.userName = res.name
      if (!this.userId) {
        this.userId = res.id
        localStorage.setItem('userId', res.id)
        this.$store.commit('addUserProp', {
          prop: 'id',
          val: res.id
        })
      }
    }
    this.$store.commit('closeLoading')
  }

  /**
   * 检查环境数据
   * @returns {Boolean} 是否检查成功
   */
  _checkEnvironmentalData() {
    // 是否通过检查
    let isPass = true
    const isTakeaway = this.$route.path.includes('/v/o/') || this.$route.path.includes('/online/')
    // 'n-t' 是无桌号入口（如 vgs 模式）的占位符，不是真实桌号，不做桌号校验
    // query 参数重复时 vue-router 会解析成数组，取第一个值
    const rawTableNumber = this.$route.query.tableNumber
    const queryTableNumber = Array.isArray(rawTableNumber) ? rawTableNumber[0] : rawTableNumber

    if (queryTableNumber && queryTableNumber !== NO_INPUT_TABLE_NUMBER) { // table 环境
      const table = this.$store?.state?.details?.table
      // 若不存在 tbale 数据，则弹窗提示
      if (!table) {
        isPass = false
      }
    } else if (isTakeaway && this.$route.query.portal === 'true' && (this.$route.query.ta === null || this.$route.query.ta === undefined)) { // takeaway 环境
      if (this.$store?.state?.details?.orderType !== 'takeaway') {
        isPass = false
      }
    } else if (this.$route.query.portal === 'true') { // counter 环境
      if (this.$store?.state?.details?.orderType !== 'dine-in') {
        isPass = false
      }
    }
    // 检查不通过时，弹窗提醒
    if (!isPass) {
      MessageDialog.$create({
        content: t('session_expired', 'Your session has expired. Please scan the QR code to start your new order.')
      }).show()
    }
    return isPass
  }

  async _addUser() {
    const data = {
      name: this.userInfo.userName.trim(),
      email: this.userInfo.emailNumber.trim(),
      phone: (this.country.dial_code + this.userInfo.phoneNumber).trim(),
      country: this.country.code.toLowerCase()
    }
    if (this.userId) data.id = this.userId
    if (this.notificationKey) data.notificationKey = this.notificationKey
    const res = await addUser(data).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    if (!this.userId && this.venueDeliverySetting?.type === 'thirdParty' && this.deliveryInfo.orderType === 'delivery') await this._getDeliveryCost(res.id)
    if (res.id) {
      localStorage.setItem('userId', res.id)
      this.$store.commit('addUserProp', {
        prop: 'id',
        val: res.id
      })
    }
    if (res.notificationKey) localStorage.setItem('notificationKey', res.notificationKey)
    return res.id
  }

  /**
   * Get third-party information according to user address
   * @param userId {String} User ID
   */
  /**
   * 根据用户地址，获取第三方信息
   * @param userId {String} 用户 id
   */
  async _getDeliveryCost(userId) {
    const {
      rawAddress,
      preOrderTimeSettings
    } = this.deliveryInfo
    let orderTime = dayjs.tz().add(this.nowDeliveryTime, 'm').format('YYYY-MM-DD HH:mm:ss')
    if (preOrderTimeSettings) orderTime = preOrderTimeSettings
    const rawAddressObj = JSON.parse(rawAddress)
    const addressInfo = {
      latitude: rawAddressObj.geometry.location.lat,
      longitude: rawAddressObj.geometry.location.lng,
      googleObject: rawAddressObj
    }
    const data = await getDeliveryCost({
      venueId: this.venueId,
      addressInfo,
      userId,
      orderInfo: {
        orderTime,
        orderType: 'delivery'
      }
    }).catch(error => {
      console.log(error)
    })
  }
}

export default ContactDetails
</script>
